/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressLineRepairResultDTOFromJSON, AddressLineRepairResultDTOToJSON, } from './AddressLineRepairResultDTO';
/**
 * Check if a given object implements the AddressLineRepairResponseDTO interface.
 */
export function instanceOfAddressLineRepairResponseDTO(value) {
    return true;
}
export function AddressLineRepairResponseDTOFromJSON(json) {
    return AddressLineRepairResponseDTOFromJSONTyped(json, false);
}
export function AddressLineRepairResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dryRun': json['dryRun'] == null ? undefined : json['dryRun'],
        'total': json['total'] == null ? undefined : json['total'],
        'repaired': json['repaired'] == null ? undefined : json['repaired'],
        'unchanged': json['unchanged'] == null ? undefined : json['unchanged'],
        'manual': json['manual'] == null ? undefined : json['manual'],
        'results': json['results'] == null ? undefined : (json['results'].map(AddressLineRepairResultDTOFromJSON)),
    };
}
export function AddressLineRepairResponseDTOToJSON(json) {
    return AddressLineRepairResponseDTOToJSONTyped(json, false);
}
export function AddressLineRepairResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'dryRun': value['dryRun'],
        'total': value['total'],
        'repaired': value['repaired'],
        'unchanged': value['unchanged'],
        'manual': value['manual'],
        'results': value['results'] == null ? undefined : (value['results'].map(AddressLineRepairResultDTOToJSON)),
    };
}
